import React from 'react';
import clsx from 'clsx';
// import { makeStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '34px',
    borderRadius: theme.palette.box.radius,
    border: theme.palette.box.border,
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'space-around',
    cursor: 'pointer',

    '&.filtered': {
      borderColor: theme.palette.primary.deep,
      backgroundColor: theme.palette.primary.deep,
      color: theme.palette.common.white,
      '& > div, & .DateRangePickerInput_arrow, & .DateInput_input': {
        backgroundColor: theme.palette.primary.deep,
        color: theme.palette.common.white,
      },
      '& .mb-division': {
        backgroundColor: theme.palette.common.white,
      },
    },
    '&.error': {
      borderColor: 'red',
    },
  },
  label: {
    flexShrink: 0,
    marginLeft: 11,
    marginRight: 11,
    '.filtered &': {
      marginRight: 0,
    },
  },
  division: {
    marginLeft: 6,
    marginRight: 6,
    width: '1px',
    height: '15px',
    backgroundColor: theme.palette.primary.division,
  },
  childDiv: {
    marginRight: 11,
  },
}));

/**
 * Popover를 사용하는 컴포넌트에 버튼을 만들어주는 컴포넌트
 */
const NewLabelFilterWrap = (props) => {
  const {
    className,
    label = '',
    filtered,
    onClick,
    children,
    anchorRef,
    error,
    ...rest
  } = props;
  const classes = useStyles();
  const viewDivision = !!children && label !== '';

  return (
    <div
      className={clsx(classes.root, className, {
        filtered,
        error,
      })}
      onClick={onClick}
      ref={anchorRef}
      {...rest}
    >
      <span className={classes.label}>{label}</span>
      {filtered && (
        <>
          {viewDivision && (
            <div className={`mb-division ${classes.division}`} />
          )}
          <div className={classes.childDiv}>{children}</div>
        </>
      )}
    </div>
  );
};

export default NewLabelFilterWrap;
